<template>
    <b-card no-body header-bg-variant="secondary">
        <template #header>
            <div class="d-flex align-items-center">
                <b-button class="toggle mr-3" size="sm" v-b-toggle="[`accordion-${index}`]" variant="light">
                    <i class="las la-angle-double-up"></i>
                </b-button>
                <a href="#" @click.prevent
                   v-b-toggle="[`accordion-${index}`]">{{ `${index + 1}. ${stage.label || 'Stage'}` }}</a>
                <b-btn size="sm" class="ml-auto" variant="light"
                       :disabled="index===0"
                       @click.prevent="onMoveUp">
                    <i class="las la-angle-up"></i>
                </b-btn>
                <b-btn size="sm" class="ml-2" variant="light"
                       :disabled="index===store.stages.length-1"
                       @click.prevent="onMoveDown">
                    <i class="las la-angle-down"></i>
                </b-btn>
                <b-btn size="sm" class="ml-2" variant="light"
                       @click.prevent="onDeleteStage">
                    <i class="la la-trash"></i>
                </b-btn>
            </div>
        </template>
        <b-collapse :id="`accordion-${index}`" accordion="stage-accordion" role="tabpanel">
            <div class="p-3">
                <b-form-group label="Label"
                              label-size="sm"
                              :label-cols-sm="1">
                    <b-form-input size="sm"
                                  v-model="stage.label"></b-form-input>
                </b-form-group>
                <b-form-group label="Operator"
                              label-size="sm"
                              :label-cols-sm="1"
                              :description="desc">
                    <b-form-select size="sm"
                                   v-model="stage.op"
                                   :options="operators"
                                   @change="onOperatorChange"></b-form-select>
                </b-form-group>
                <template v-if="stage.op">
                    <template v-if="getValueComponent(stage.op)">
                        <component :is="getValueComponent(stage.op)" :index="index"></component>
                    </template>
                </template>
                <b-form-group label="Discount modifier"
                              label-size="sm"
                              :label-cols-sm="1"
                              description="Format: '[+|-|*]:digit[%]' Example: +30%">
                    <b-form-input size="sm"
                                  v-model="stage.modifier"></b-form-input>
                </b-form-group>
            </div>
        </b-collapse>


    </b-card>

</template>

<script>
import store from "./store";
import IfValue from "./value/IfValue.vue";
import ArrayValue from "./value/ArrayValue.vue";
import AgeValue from "./value/AgeValue.vue";
import _ from "lodash";
import AtrcLevelValue from "./value/AtrcLevelValue.vue";
import DateBetweenValue from "./value/DateBetweenValue.vue";
import EqValue from "./value/EqValue.vue";
import InValue from "./value/InValue.vue";
import RegexValue from "./value/RegexValue.vue";
import AtrcNAValue from "./value/AtrcNAValue.vue";
import AtrcNYearsNoClaims from "./value/AtrcNYearsNoClaims.vue";
import DallboggSconto from "./value/DallboggSconto.vue";

export default {
    name: 'StageRow',
    components: {
        IfValue,
        ArrayValue,
        AgeValue,
        AtrcLevelValue,
        DateBetweenValue,
        EqValue,
        InValue,
        RegexValue,
        AtrcNAValue,
        AtrcNYearsNoClaims,
        DallboggSconto,
    },
    props: {
        index: {
            type: Number,
            required: true
        }
    },
    computed: {
        stage() {
            return store.stages[this.index]
        },
        store() {
            return store
        },
        desc() {
            return _.get(this.store.operators[this.stage.op], 'description', '');
        },
        operators() {
            return Object.keys(this.store.operators).sort().map(key => ({
                value: key,
                text: key
            }))
        }
    },
    methods: {
        getValueComponent(op) {
            return _.get(this.store.operators[op], 'value_component', 'ArrayValue');
        },
        onOperatorChange(op) {
            //we do not like uniform
            if (op === '$if') {
                this.stage.value = {
                    comparison: null,
                    then: null,
                    else: null
                }
            } else {
                this.stage.value = []

            }
        },
        onDeleteStage() {
            this.store.stages.splice(this.index, 1)
        },
        onMoveUp() {
            let tmp = this.store.stages[this.index]
            this.$set(this.store.stages, this.index, this.store.stages[this.index - 1])
            this.$set(this.store.stages, this.index - 1, tmp)
        },
        onMoveDown() {
            let tmp = this.store.stages[this.index]
            this.$set(this.store.stages, this.index, this.store.stages[this.index + 1])
            this.$set(this.store.stages, this.index + 1, tmp)
        },
    }
}
</script>

<style scoped lang="scss">
.card {
    margin-bottom: 0.5rem;
}

.toggle {
    &.collapsed {
        i {
            rotate: 180deg;
        }
    }
}
</style>
